import type { HolisticSummaryCategory } from '@fruitful/types';
import {
    H1Regular,
    Icon,
    InfoButton,
    isWeb,
    Private,
    SafeAreaView,
    Spinner,
    XStack,
    YStack,
} from 'smoothie';

import {
    centsToDollars,
    formatDollars,
} from '../../../common/utils/bankingUtils';
import { CATEGORY_INFO_MAP } from '../../constants';
import { AccountCategoryIcons } from '../../types/HolisticSummary';

interface CategoryHeaderProps {
    category: HolisticSummaryCategory;
    totalCurrentBalanceCents?: number | null;
    onPressInfoIcon: () => void;
}

export const HolisticCategoryHeader = ({
    category,
    totalCurrentBalanceCents,
    onPressInfoIcon,
}: CategoryHeaderProps) => {
    const { headerTitle } = CATEGORY_INFO_MAP[category];
    const icon = AccountCategoryIcons[category];
    const accountBalanceLoading =
        totalCurrentBalanceCents === undefined ||
        totalCurrentBalanceCents === null;

    return (
        <SafeAreaView edges={['top', 'left', 'right']}>
            <YStack marginTop={isWeb ? 90 : 60} alignItems="center">
                <Icon icon={icon} color="$black" size={30} />
                <XStack alignItems="center" gap={8}>
                    <InfoButton text={headerTitle} onPress={onPressInfoIcon} />
                </XStack>
                <Private>
                    {accountBalanceLoading ? (
                        <YStack>
                            <Spinner />
                        </YStack>
                    ) : (
                        <H1Regular>
                            {formatDollars(
                                centsToDollars(totalCurrentBalanceCents),
                            )}
                        </H1Regular>
                    )}
                </Private>
            </YStack>
        </SafeAreaView>
    );
};
